import { p as parseCookies } from "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
const extractMktgIds = () => {
  const cookies = parseCookies();
  if (cookies._fbc || cookies._fbp || cookies._ttp) {
    return {
      ...cookies._fbc && { fbc: cookies._fbc },
      ...cookies._fbp && { fbp: cookies._fbp },
      ...cookies._ttp && { ttp: cookies._ttp }
    };
  } else {
    return void 0;
  }
};
export {
  extractMktgIds
};
